interface Props {
  children?: React.ReactNode;
}

export const MainBoxDetailsColumn: React.FC<Props> = ({ children }) => {
  return (
    <>
      <div className="flex grid-cols-2 justify-between">{children}</div>
    </>
  );
};
